module.exports = "<script type=\"text/ng-template\" id=\"candidateProfileModal.html\">\n  <candidate-profile  profile-user=\"candidateId\" />\n</script>\n"


//////////////////
// WEBPACK FOOTER
// ./scripts/shared/directives/candidate-profile-modal/candidate-profile-modal.template.html
// module id = 454
// module chunks = 0